module.exports = __webpack_public_path__ + "img/keep.22735f76.svg";